import React from "react";
import { default as MainTitle } from "./MainTitle";
import { default as Body } from "./Body";
import { default as Footer } from "./Footer";
import "../SimulatorInfo.css";

export default function LeftOverlay({
  pageJSON,
  simPageNum,
  singleScreenStep,
  setIsSingleStepScreen,
  setSingleScreenStepLength,
  emulatorStep,
  isSingleStepScreen,
}) {
  const myJSON = pageJSON[simPageNum].content_data;
  return (
    <div
      className="left-half-info-page-container"
      style={{
        animation: myJSON.fade_in_delay
          ? `.5s fadeIn ${myJSON.fade_in_delay} linear forwards`
          : null,
        opacity: myJSON.fade_in_delay ? "0" : "1",
        backgroundColor:
          myJSON.steps &&
          myJSON.steps[emulatorStep] &&
          myJSON.steps[emulatorStep].custom_overlay &&
          myJSON.steps[emulatorStep].custom_overlay.background_color
            ? myJSON.steps[emulatorStep].custom_overlay.background_color
            : myJSON.left_overlay_color
            ? myJSON.left_overlay_color
            : "rgba(0,0,0,0)",
        height: !myJSON.body ? "20%" : "100%",
      }}
    >
      <div
        className="left-half-info-page-text"
        style={{
          justifyContent:
            myJSON.body && myJSON.body.flex_justify
              ? myJSON.body.flex_justify
              : "flex-start",
          transformOrigin:
            myJSON.body && myJSON.body.transform_origin
              ? myJSON.body.transform_origin
              : "top left",
          height: !myJSON.body ? "20%" : "100%",
        }}
      >
        {myJSON.title && myJSON.title.main_title ? (
          <MainTitle myJSON={myJSON} emulatorStep={emulatorStep} />
        ) : null}

        {myJSON.body ? (
          <Body
            side="left"
            myJSON={myJSON}
            emulatorStep={emulatorStep}
            setIsSingleStepScreen={setIsSingleStepScreen}
            setSingleScreenStepLength={setSingleScreenStepLength}
            singleScreenStep={singleScreenStep}
          />
        ) : null}
        {myJSON.footer ? (
          <Footer
            myJSON={myJSON.footer}
            singleScreenStep={singleScreenStep}
            setIsSingleStepScreen={setIsSingleStepScreen}
            setSingleScreenStepLength={setSingleScreenStepLength}
            isSingleStepScreen={isSingleStepScreen}
          />
        ) : null}
      </div>
    </div>
  );
}
